module.exports = __webpack_public_path__ + "img/20210610-IMG_0685.2813f5c4.jpg";